@if (layoutBlanc()) {
  <router-outlet></router-outlet>
} @else {
  <div class="app-shell">

    <app-menu></app-menu>

    <main class="dashboard">
      <app-toolbar></app-toolbar>

      <section class="content-grid" [class.content-grid-full]="!afficherSiloParc()">
        @if (afficherSiloParc()) {
          <app-silo-parc style="overflow: auto;"></app-silo-parc>
        }

        <div style="overflow: auto; min-height: 0;">
          <router-outlet></router-outlet>
        </div>
      </section>
    </main>
  </div>
}
